import * as React from 'react'
import { VyneRadio } from '@vynedental/design-system'
import { RadioChangeEvent } from 'antd'

import './WidgetStyle.sass'

export type WidgetStyleProps = {
    customValue?: Api.widgetStyle | boolean
    updateWidgetStyle: (widgetStyle: Api.widgetStyle) => void
}

export default class WidgetStyle extends React.Component<WidgetStyleProps> {
    updateWidgetStyle = (e: RadioChangeEvent) => {
        this.props.updateWidgetStyle(e.target.value as Api.widgetStyle)
    }

    render() {
        const { customValue } = this.props
        const radioValue = customValue || 'expanded'

        return (
            <div className="widget-style">
                <h3>Style:</h3>
                <div className="radio-wrapper">
                    <VyneRadio
                        dataTestId="widget-style-expanded"
                        checked={radioValue === 'expanded'}
                        onChange={this.updateWidgetStyle}
                        name="radio-widget-style"
                        value="expanded"
                        isStandalone
                        style={{ marginBottom: 0 }}
                    >
                        Expanded
                    </VyneRadio>
                </div>
                <div className="radio-wrapper">
                    <VyneRadio
                        dataTestId="widget-style-condensed"
                        checked={radioValue === 'condensed'}
                        onChange={this.updateWidgetStyle}
                        name="radio-widget-style"
                        value="condensed"
                        isStandalone
                        style={{ marginBottom: 0 }}
                    >
                        Condensed
                    </VyneRadio>
                </div>
            </div>
        )
    }
}
